import React from "react";
import axios from "axios";
import "./ECommerce.css";
import "../Page.css";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import SearchBar from "../../Components/UI-Controls/SearchBar/Search";
import searchIcon from "../../Assets/Images/Search Bar 20 x 20.png";
import actionIcon from "../../Assets/Images/ActionBtn 30 x 30.png";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { useState, useEffect, useRef } from "react";
import { security_key, Url } from "../../Services/Api";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import ElipticalPagenation from "../../Components/UI-Controls/Pagination/Pagination2";
import defaultImage from "../../Assets/Images/defaultBannerImage 128 x 128.png";
import PriceRange from "../../Components/UI-Controls/RangeFilter/PriceRange";
import CustomDropdown from "../../Components/UI-Controls/Dropdown/dropdown";
import RatingReview from "../../Components/UI-Controls/StarRating/Rating";
import SearchMultiple from "../../Components/UI-Controls/MultiSelect/Multiselect";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import BottomToust from "../../Components/BottomToust/BottomToust";
import { CiWarning } from "react-icons/ci";
import { IoEyeOutline } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import { HiOutlineDocumentDuplicate } from "react-icons/hi";
import CustomBtnLogo from "../../Components/UI-Controls/Buttons/BtnLogo";

import logo from "../../Assets/merchant.png"
import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";
import SearchSingle from "../../Components/UI-Controls/MultiSelect/SingleSelect";
import ToggleSwitch from "../../Components/UI-Controls/ToggleSwitch/toggleSwitch";
import CustomCheckbox from "../../Components/CustomCheckBox/CustomCheckbox";

import tag1 from "../../Assets/tag1.png"

import { DatePicker } from "antd";
import PriceChangePopUp from "../../Components/ProductPagePopup/priceChangePopup";

const AllProducts = () => {
  const { RangePicker } = DatePicker;
  const disabledDate = (current) => {
    return current && current > new Date();
  };
  const rowsPerPage = 10;
  const navigate = useNavigate();
  const modalRef = useRef(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [rating, setRating] = useState("");
  const [priceRange, setPriceRange] = useState("");
  const [selectedTrandingStatus, setSelectedTrandingStatus] = useState(null);
  const [selectedProductStatus, setSelectedProductStatus] = useState(null);
  const [selectedStockStatus, setSelectedStockStatus] = useState(null);
  const [selectedCollection, setSelectedCollection] = useState({ label: "", value: "" });
  const [categories, setCategories] = useState([]);
  const [collections, setCollections] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [filtersModified, setFiltersModified] = useState(false);
  const [dateRange, setDateRange] = useState(null);
  const [originalData, setOriginalData] = useState([]);
  const [filteredData, setFilteredData] = useState(data);
  const [selectedTags, setSelectedTags] = useState([]);
  const [tagselect, setTagSelect] = useState([]);
  const [selectedTagType, setSelectedTagType] = useState(null);
  const [tags, setGetTags] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [showMessage, setShowMessage] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [showAllConfirm, setShowAllConfirm] = useState(false);
  const [currentRowId, setCurrentRowId] = useState(null);
  const [isActive, setIsActive] = useState(false);
  const [error, setError] = useState(null);

  const [showVariations, setShowVariations] = useState(false);
  const [showDyrc, setShowDyrc] = useState(false);
  const [showSubProducts, setShowSubProducts] = useState(false);


  const [dataSource, setDataSource] = useState("default");
  const [searchText, setSearchText] = useState("");
  const [filtersPayload, setFiltersPayload] = useState(null);




  useEffect(() => {
    fetchCategories();
    fetchCollections();
  }, []);

  const handleCloseMessageModal = () => {
    setShowMessage(false);
  };

  useEffect(() => {
    if (showMessage === true) {
      const timeOut = setTimeout(() => {
        setShowMessage(false);
      }, 3000);

      return () => clearTimeout(timeOut);
    }
  }, [showMessage]);

  const fetchCategories = async () => {
    try {
      const response = await fetch(
        `${Url}/api/v1/productCategory/get`
      );
      const data = await response.json();

      if (!data || !data.categories) {
        console.error("No categories found in the response data");
        setCategories([]);
        return;
      }

      const allCategories = data.categories
        .filter((category) => category.name)
        .map((category) => ({
          label: category.name,
          value: category.uid,
        }));

      setCategories(allCategories);
    } catch (error) {
      console.error("Error fetching categories:", error);
      setCategories([]);
    }
  };


  const fetchCollections = async () => {
    try {
      const response = await fetch(
        `${Url}/api/v1/collections/get`
      );
      const data = await response.json();

      if (!data || !data.data) {
        console.error("No categories found in the response data");
        setCategories([]);
        return;
      }

      const allCollections = data.data
        .filter((category) => category.name)
        .map((category) => ({
          label: category.name,
          value: category.uid,
        }));

      setCollections(allCollections);
    } catch (error) {
      console.error("Error fetching collections:", error);
      setCollections([]);
    }
  };

  const [merchantLoading, setMerchantLoading] = useState(false);
  const setMerchantSystem = async () => {
    const token = sessionStorage.getItem('authToken');
    const headers = {
      Authorization: `Bearer ${token}`,
      'x-api-key': security_key
    };
    setMerchantLoading(true)
    try {
      const response = await fetch(`${Url}/api/export-products`, { headers: headers });

      if (!response.ok) {
        console.error("Error fetching data:", response.statusText);
        setMerchantLoading(false)
        return;
      }
      setMerchantLoading(false)
      setShowMessage(true)
      setToastMessage("Merchant Center Sheet has been Updated.")


    } catch (error) {
      setMerchantLoading(false)
      setShowMessage(true)
      setToastMessage("There is an error while updating Merchant sheet.")
      console.error("Error during fetch:", error);
    }
  };

  const handleCategorySelect = (categoryLabel) => {
    setSelectedCategories((prevCategories) => {
      const isCategorySelected = prevCategories.some(
        (category) => category.label === categoryLabel
      );

      if (isCategorySelected) {
        setFiltersModified(true);
        return prevCategories.filter(
          (category) => category.label !== categoryLabel
        );
      } else {
        const selectedCategory = categories.find(
          (category) => category.label === categoryLabel
        );
        if (selectedCategory) {
          setFiltersModified(true);
          return [
            ...prevCategories,
            { label: selectedCategory.label, uid: selectedCategory.value },
          ];
        }
        return prevCategories;
      }
    });
  };



  // const handleFilters = () => {
  //   if (
  //     !rating &&
  //     !priceRange &&
  //     !selectedTrandingStatus &&
  //     !selectedProductStatus &&
  //     !selectedStockStatus &&
  //     !selectedCollection.value &&
  //     !selectedCategories.length &&
  //     !selectedTags.length &&
  //     (!dateRange || dateRange.length !== 2)
  //   ) {
  //     let warningMessage = "Kindly select or enter respective filtration value...";
  //     setToastMessage(warningMessage);
  //     setShowMessage(true);
  //     return;
  //   }

  //   console.log("Selected Filters:", {
  //     rating,
  //     priceRange,
  //     selectedTrandingStatus,
  //     selectedProductStatus,
  //     selectedStockStatus,
  //     selectedCategories,
  //     dateRange,
  //     selectedTags,
  //     selectedCollection,
  //     showVariations
  //   });

  //   const filteredData = data.filter((item) => {
  //     const stockMatch = selectedStockStatus
  //       ? item.manage_stock?.stock_status.toLowerCase() ===
  //       selectedStockStatus.toLowerCase()
  //       : true;

  //     const statusMatch = selectedProductStatus
  //       ? item.status.toLowerCase() === selectedProductStatus.toLowerCase()
  //       : true;

  //     const trandingMatch = selectedTrandingStatus
  //       ? item[selectedTrandingStatus] === 1
  //       : true;

  //     const categoryMatch = selectedCategories.length
  //       ? selectedCategories.some((category) =>
  //         item.categories.some(
  //           (itemCategory) => itemCategory.uid === category.uid
  //         )
  //       )
  //       : true;

  //     const ratingMatch = rating
  //       ? parseFloat(item.rating_count) === parseFloat(rating)
  //       : true;

  //     const priceRangeMatch =
  //       priceRange && item.regular_price
  //         ? parseFloat(item.regular_price) <= parseFloat(priceRange)
  //         : true;

  //     const tagMatch = selectedTags.length
  //       ? item.tags.some((tag) => tag.name === selectedTags[0].name)
  //       : true;

  //     return (
  //       stockMatch &&
  //       trandingMatch &&
  //       statusMatch &&
  //       categoryMatch &&
  //       priceRangeMatch &&
  //       tagMatch &&
  //       ratingMatch
  //     );
  //   });

  //   setFilteredData(filteredData);
  //   setFiltersApplied(true);
  //   setFiltersModified(false);
  // };

  const handleFilters = async (incomingPayload = null, page = 1) => {
    const hasFilters =
      rating ||
      priceRange ||
      (selectedTrandingStatus?.length > 0) ||
      selectedProductStatus ||
      selectedStockStatus ||
      showDyrc ||
      showSubProducts ||
      selectedCollection?.value ||
      selectedCategories.length > 0 ||
      selectedTags.length > 0 ||
      (dateRange && dateRange.length === 2);

    if (!hasFilters && !incomingPayload) {
      let warningMessage = "Kindly select or enter respective filtration value...";
      setToastMessage(warningMessage);
      setShowMessage(true);
      return;
    }

    const payload = incomingPayload ?? {
      ...(rating && rating !== "" && { rating }),
      ...(priceRange && priceRange !== "" && { priceRange }),
      ...(selectedTrandingStatus?.length > 0 && { selectedTrandingStatus }),
      ...(selectedProductStatus && { selectedProductStatus }),
      ...(selectedStockStatus && { selectedStockStatus }),
      ...(selectedCategories.length > 0 && { selectedCategories }),
      ...(dateRange?.length === 2 && dateRange[0] && dateRange[1] && { dateRange }),
      ...(selectedTags.length > 0 && { selectedTags }),
      ...(selectedCollection?.value && { selectedCollection: selectedCollection.value }),
      showVariables: showVariations,
      showDyr: showDyrc,
      showSubProducts: showSubProducts
    };

    const updatedPayload = { ...payload, page, limit: 50 };

    setDataSource("filters");
    setFiltersPayload(payload);
    if (page === 1) setCurrentPage(1);

    try {
      setFilterLoading(true);
      console.log("Sending filters to backend:", updatedPayload);

      const response = await axios.post(
        `${Url}/api/v1/products/get-filtered`,
        updatedPayload
      );

      const { products, pagination } = response.data;

      setFilteredData(products);
      setTotalPages(pagination.totalPages);
      setFiltersApplied(true);
      setFiltersModified(false);
      setFilterLoading(false);
    } catch (error) {
      console.error("Error fetching filtered products:", error);
      setToastMessage("Error fetching filtered products.");
      setShowMessage(true);
      setFilterLoading(false);
    }
  };




  useEffect(() => {
    if (filtersApplied && filtersModified) {
      handleFilters();
      setFiltersModified(false);
    }
  }, [
    rating,
    priceRange,
    selectedTrandingStatus,
    selectedProductStatus,
    selectedStockStatus,
    selectedCategory,
    selectedTags,
    filtersApplied,
    filtersModified,
  ]);

  const handleFilterChange = (value, fieldName) => {
    if (fieldName === "priceRange") {
      setPriceRange(value);
    } else if (fieldName === "rating") {
      setRating(value);
    } else if (fieldName === "stock") {
      setSelectedStockStatus(value);
    } else if (fieldName === "date") {
      setDateRange(value);
    } else if (fieldName === "status") {
      setSelectedProductStatus(value);
    } else if (fieldName === "tranding") {
      setSelectedTrandingStatus(value);
    } else if (fieldName === "category") {
      setSelectedCategories(value);
    } else if (fieldName === "date") {
      setDateRange(value);
    }
    setFiltersModified(true);
  };

  const handleResetFilters = () => {
    setDataSource("default");


    setRating("");
    setPriceRange("");
    setSelectedTrandingStatus(null);
    setSelectedProductStatus(null);
    setSelectedStockStatus(null);
    setSelectedCategory(null);
    setDateRange(null);
    setSelectedTags([]);
    setSelectedCategories([]);
    setSelectedTagType(null);
    setFiltersApplied(false);
    setFiltersModified(false);
    setCurrentPage(1);
    fetchTableData(1);
  };

  const productStockOptions = [
    { value: "inStock", label: "In Stock" },
    { value: "outStock", label: "Out of Stock" },
  ];

  const productStatusOptions = [
    { value: "draft", label: "Draft" },
    { value: "published", label: "Published" },
  ];

  const ratingOptions = [
    { value: "1", label: "⭐" },
    { value: "2", label: "⭐⭐" },
    { value: "3", label: "⭐⭐⭐" },
    { value: "4", label: "⭐⭐⭐⭐" },
    { value: "5", label: "⭐⭐⭐⭐⭐" }
  ];


  const trendingOptions = [
    { value: "deal_of_month", label: "Deal of the Month" },
    { value: "best_selling_product", label: "Best Selling Product" },
    { value: "featured", label: "Featured Product" },
  ];

  useEffect(() => {
    if (dataSource === "default") {
      fetchTableData(currentPage);
    } else if (dataSource === "search") {
      searchForProducts(searchText, currentPage);
    } else if (dataSource === "filters") {
      handleFilters(filtersPayload, currentPage);
    }
  }, [currentPage, dataSource]);


  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await axios.get(
          `${Url}/api/v1/productTag/get`
        );
        const data = response.data.productTags;
        const formattedTags = data.map((tag) => ({
          _id: tag._id,
          uid: tag.uid,
          name: tag.name,
          slug: tag.slug,
          text: tag.text,
          type: tag.type,
          bg_color: tag.bg_color,
          text_color: tag.text_color,
        }));
        setGetTags(formattedTags);
      } catch (error) {
        console.error("Error fetching tags:", error);
      }
    };
    fetchTags();
  }, []);

  useEffect(() => {
    if (tagselect) {
    }
  }, [tagselect]);

  /* --- Function for Handling of Tag Selection in Product Data General Tab --- */
  const handleTagSelect = (tagName) => {
    setSelectedTags((prevTags) => {
      const isTagSelected = prevTags.some((tag) => tag.name === tagName);
      if (isTagSelected) {
        setFiltersModified(true);
        return [];
      } else {
        const selectedTag = tags.find((tag) => tag.name === tagName);
        if (selectedTag) {
          setFiltersModified(true);
          return [selectedTag];
        }
        return prevTags;
      }
    });
  };


  async function fetchTableData(page = 1, limit = 50) {
    setLoading(true);
    setError(null);

    try {
      const response = await axios.get(`https://fdapi.thefurnituredepots.com/api/v1/products/get`, {
        params: {
          page,
          limit,
          parent: 0, // only fetch parent: 0 products if required
        },
      });

      const products = response.data.products;
      const pagination = response.data.pagination;

      setData(products);
      setOriginalData(products);
      setFilteredData(products);
      setTotalPages(pagination.totalPages);
      // setCurrentPage(pagination.currentPage);

      setToastMessage("Products fetched successfully!");
      setShowMessage(true);
    } catch (error) {
      const errMsg = error?.response?.data?.message || error.message;
      setError(errMsg);
      setToastMessage(`Failed to fetch Products Data: ${errMsg}`);
      setShowMessage(true);
    } finally {
      setLoading(false);
    }
  }


  const convertToCSV = (data) => {
    if (!data) return "";

    const flattenObject = (obj, parentKey = "", result = {}) => {
      for (let key in obj) {
        const propName = parentKey ? `${parentKey}.${key}` : key;
        if (typeof obj[key] === "object" && obj[key] !== null) {
          flattenObject(obj[key], propName, result);
        } else {
          result[propName] = obj[key];
        }
      }
      return result;
    };

    const flattenedData = data.map((row) => flattenObject(row));
    const keys = Object.keys(flattenedData[0]);
    const header = keys.join(",");
    const rows = flattenedData.map((row) =>
      keys.map((key) => (row[key] === undefined ? "" : row[key])).join(",")
    );

    return [header, ...rows].join("\n");
  };

  const handleExport = async () => {
    try {
      if (data.length === 0) {
        await fetchTableData(currentPage);
      }

      const dataToExport =
        selectedRows.size > 0
          ? data.filter((row) => selectedRows.has(row._id))
          : data;

      const csv = convertToCSV(dataToExport);

      if (!csv) throw new Error("No data to export");
      let successMessage = "Data has been exported successfully!";
      const blob = new Blob([csv], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "Product_Record.csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setToastMessage(successMessage);
      setShowMessage(true);
    } catch (error) {
      let errorMessage = "Something went wrong. Kindly check it carefully.";
      console.error(error);
      setToastMessage(errorMessage);
      setShowMessage(true);
    }
  };

  const handleRowSelection = (rowId) => {
    setSelectedRows((prevSelected) => {
      if (prevSelected.has(rowId)) {
        const updatedSet = new Set(prevSelected);
        updatedSet.delete(rowId);
        return updatedSet;
      } else {
        return new Set([...prevSelected, rowId]);
      }
    });
    console.log(selectedRows, "here")
  };

  const handleAddProduct = () => {
    navigate("/E-Commerce/Add-Product");
  };

  const getAllFunction = async () => {
    const extracted = originalData.flatMap(item => {
      const processItem = (obj) => {
        const {
          uid,
          _id,
          name,
          sale_price,
          regular_price,
          parent,
          short_description,
          mpn,
          gtin,
          ean,
          image,
          images,
          attributes,
          manage_stock,
          brand
        } = obj;

        const singleImageUrl = Url + (image?.image_url || '');
        const imagesUrls = Array.isArray(images)
          ? images.map(img => Url + img.image_url).filter(Boolean).join(', ')
          : '';

        // 🔍 Extract color from attributes
        let color = '';
        if (Array.isArray(attributes)) {
          const colorAttr = attributes.find(attr => attr.name === 'Select Color');
          if (colorAttr && Array.isArray(colorAttr.options) && colorAttr.options.length > 0) {
            color = colorAttr.options[0].name || '';
          }
        }

        return {
          uid,
          _id,
          name,
          sale_price,
          regular_price,
          parent,
          short_description,
          mpn,
          gtin,
          ean,
          image_url: singleImageUrl,
          images_urls: imagesUrls,
          attributes: attributes,
          color: color,
          stock: manage_stock ? manage_stock.stock_status : "",
          brand
        };
      };

      if (item.type === "variable") {
        return item.variations.map(processItem);
      } else {
        return [processItem(item)];
      }
    });

    console.log(extracted);
  };

  const handleImport = () => {
    getAllFunction();
  };

  // const handleSearch = async (searchValue) => {
  //   if (!searchValue) {
  //     fetchTableData(currentPage);
  //     return;
  //   }

  //   try {
  //     const response = await searchForProducts(searchValue);
  //     setFilteredData(response.data.products);
  //   } catch (error) {
  //     console.error("Error fetching data", error);
  //   }
  // };


  const handleSearch = async (searchValue, page = 1) => {
    if (!searchValue) {
      setDataSource("default");
      setCurrentPage(1);
      fetchTableData(1);
      return;
    }

    setSearchText(searchValue);
    setDataSource("search");
    if (page === 1) setCurrentPage(1); // avoid infinite loop

    try {
      const response = await searchForProducts(searchValue, page);

      setFilteredData(response.data.products);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };


  // const searchForProducts = async (text) => {
  //   setError(null);
  //   const api = `/api/v1/products/by-name?name`;
  //   try {
  //     const response = await axios.get(`${Url + api}=${text}`);
  //     setToastMessage("Sorted Products have been fetched successfully!");
  //     setShowMessage(true);
  //     return response;
  //   } catch (error) {
  //     const errMsg = error?.response?.data?.message || error.message;
  //     setError(errMsg);
  //     setToastMessage(`Failed to fetch Sorted Products: ${errMsg}`);
  //     setShowMessage(true);
  //     throw error;
  //   }
  // };

  const searchForProducts = async (text, page = 1) => {
    setError(null);
    const api = `/api/v1/products/by-name?name=${text}&page=${page}&limit=50`;
    try {
      const response = await axios.get(Url + api);
      setToastMessage("Sorted Products have been fetched successfully!");
      setShowMessage(true);
      return response;
    } catch (error) {
      const errMsg = error?.response?.data?.message || error.message;
      setError(errMsg);
      setToastMessage(`Failed to fetch Sorted Products: ${errMsg}`);
      setShowMessage(true);
      throw error;
    }
  };


  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 1500);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 1500);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const customStyles = {
    headCells: {
      style: {
        height: "clamp(50px, 5vw, 56px)",
        background: "transparent",
        opacity: "1",
        textAlign: "center",
        justifyContent: "center",
        border: "none",
        color: "var(--text-color-1)",
        fontFamily: "var(--font-family)",
        fontWeight: "var(--font-weight-medium)",
        fontSize: "clamp(var(--font-size-medium), 0.8vw, calc(var(--font-size-medium) + 2px))",
      },
    },
    cells: {
      style: {
        height: "clamp(50px, 6vw, 66px)",
        justifyContent: "center",
        textAlign: "center",
        background: "transparent",
        borderTop: "var(--standered-border)",
        borderRight: "none",
        color: "var(--text-color-1)",
        fontFamily: "var(--font-family)",
        fontWeight: "var(--font-weight-regular)",
        fontSize: "clamp(var(--font-size-small), 0.8vw, calc(var(--font-size-small) + 2px))",
      },
    },
  };

  const toggleDropdown = (id) => {
    setOpenDropdownId((prevId) => (prevId === id ? null : id));
  };

  const [productPChange, setProductPChange] = useState(null);
  const [showProductPChangeModal, setShowProductPChangeModal] = useState(false);

  const updateProduct = async (data) => {
    try {
      setMerchantLoading(true);
      setShowProductPChangeModal(false);
      const token = sessionStorage.getItem('authToken');
      const headers = {
        Authorization: `Bearer ${token}`,
        "x-api-key": security_key
      };

      const response = await axios.post(
        `${Url}/api/v1/products/update-price-stock`,
        data,
        { headers }
      );


      setMerchantLoading(false);
      setToastMessage('Product has been updated successfully!');
      setShowMessage(true);
      fetchTableData(currentPage);
      setProductPChange(null)
      return response.data;

    } catch (error) {
      setShowProductPChangeModal(true);
      setMerchantLoading(false);
      setToastMessage(error);
      setShowMessage(true);
    } finally {
      setMerchantLoading(false);
    }
  };


  const handleAction = (action, row) => {
    console.log(`Action: ${action} triggered for row:`, row);
    switch (action) {
      case "edit":
        if (row.parent === 0) {
          handleEdit(row);
        } else {
          let errorMessage = "Not edited due to single product of Variable type.";
          setToastMessage(errorMessage);
          setShowMessage(true);
        }
        setOpenDropdownId(null);
        break;
      case "delete":
        confirmDelete(row);
        setOpenDropdownId(null);
        break;
      case "duplicate":
        console.log(row)
        setProductPChange(row);
        setShowProductPChangeModal(true);
        break;
      case "view":
        handleView(row);
        setOpenDropdownId(null);
        break;
      default:
        break;
    }
  };

  const confirmDelete = (row) => {
    setCurrentRowId(row.uid);
    setShowConfirm(true);
  };


  const [loadingBulkDelete, setLoadingBulkDelete] = useState(false);
  const confirmBulkDelete = () => {

    setShowAllConfirm(true);
  };

  const BulkDelete = async (selectedIds) => {
    setLoadingBulkDelete(true);
    setIsActive(true);
    const selectedRowsList = Array.from(selectedRows);

    try {
      let successMessage = "Product deleted successfully!";
      const token = sessionStorage.getItem('authToken');
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        'x-api-key': security_key
      };

      const response = await fetch(`${Url}/api/v1/products/bulk-delete`, {
        method: "DELETE",
        headers: headers,
        body: JSON.stringify({ ids: selectedRowsList }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();

      // setData((prevItems) => prevItems.filter((item) => !selectedIds.includes(item._id)));

      setToastMessage(successMessage);
      setShowMessage(true);

      fetchTableData(currentPage);
    } catch (error) {
      let errorMessage = "Failed to delete the selection. Please try again.";
      console.error("Error deleting item:", error);
      setToastMessage(errorMessage);
      setShowMessage(true);
    } finally {
      setTimeout(() => {
        setLoadingBulkDelete(false);
        setIsActive(false);
      }, 5000);
      setShowConfirm(false);
    }
  };

  const cancelDelete = () => {
    setShowConfirm(false);
  };

  const handleClickOutside = (event) => {
    if (
      !event.target.closest(".dropdown-menu") &&
      !event.target.closest(".bar-icon")
    ) {
      setOpenDropdownId(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleDelete = () => {
    console.log(`Deleting item with ID: ${currentRowId}`);
    if (currentRowId) {
      deleteItem(currentRowId);
    }
  };

  const deleteItem = async (id) => {
    setIsLoading(true);
    setIsActive(true);

    try {
      let successMessage = "Product deleted successfully!";
      const token = sessionStorage.getItem('authToken');
      const headers = {
        Authorization: `Bearer ${token}`,
        'x-api-key': security_key
      };

      const response = await fetch(`${Url}/api/v1/products/delete/${id}`, {
        method: "DELETE",
        headers
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const responseData = await response.json();
      setData((prevItems) => prevItems.filter((item) => item._id !== id));

      setToastMessage(successMessage);
      setShowMessage(true);

      fetchTableData(currentPage);
    } catch (error) {
      let errorMessage = "Failed to delete the selection. Please try again.";
      console.error("Error deleting item:", error);
      setToastMessage(errorMessage);
      setShowMessage(true);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
        setIsActive(false);
      }, 5000);
      setShowConfirm(false);
    }
  };

  /* --- Function to Handle Display of Confirmation Dialogue Box of Delete Action --- */
  const handleDeleteClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      cancelDelete();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleDeleteClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleDeleteClickOutside);
    };
  }, []);

  const ProductsColumns = [
    {
      name: (
        <input
          type="checkbox"
          style={{ margin: 0 }}
          onChange={(e) => {
            const isChecked = e.target.checked;
            if (isChecked) {
              setSelectedRows(new Set(data.map((row) => row._id)));
            } else {
              setSelectedRows(new Set());
            }
          }}
          checked={selectedRows.size === data.length && data.length > 0}
        />
      ),
      cell: (row) => (loading ? <ShimmerLoader width="20px" height="20px" /> :
        <input
          type="checkbox"
          style={{ margin: 0 }}
          checked={selectedRows.has(row._id)}
          onChange={(e) => handleRowSelection(row._id, e.target.checked)}
        />
      ),
      ignoreRowClick: true,
      width: "50px",
    },
    {
      name: "Image",
      cell: (row) => (
        loading ? (
          <ShimmerLoader width="60px" height="50px" />
        ) : (
          <div className="p_img_1" style={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <div className="blinking_wrapper">
              {row?.dyrc?.active === 1 ? (
                <div className="blinking_1">
                  <span></span>
                </div>
              ) : (
                // empty box to preserve space
                <div style={{ width: "20px", height: "20px" }}></div>
              )}
            </div>

            <img
              key={row.image?._id}
              src={
                row.image
                  ? row?.outSource ? (`${row.image?.image_url}`) : (`https://fdapi.thefurnituredepots.com${row.image?.image_url}`)
                  : defaultImage
              }
              alt={row?.name}
              height="40px"
              style={{ objectFit: "cover" }}
            />
          </div>
        )
      ),
      minWidth: "100px",
      maxWidth: "140px",
    },

    {
      name: "Name",
      selector: (row) => (loading ? <ShimmerLoader width="80px" height="22.5px" borderRadius="20px" /> :
        <span
          onClick={() => handleView(row)}
          style={{
            cursor: "pointer",
            color: "var(--primary-color)",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 3,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            maxHeight: "54px",
          }}
        >
          {row.name ? row.name : "N/A"}
        </span>
      ),
      minWidth: "160px",
      maxWidth: "260px",
    },
    {
      name: "SKU",
      selector: (row) => (loading ? <ShimmerLoader width="80px" height="22.5px" borderRadius="20px" /> :
        <span
          onClick={() => handleView(row)}
          style={{
            cursor: "pointer",
            color: "var(--primary-color)",
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 3,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            maxHeight: "54px",
          }}
        >
          {row.sku ? row.sku : "N/A"}
        </span>
      ),
      minWidth: "140px",
      maxWidth: "240px",
    },
    {
      name: "Stock",
      cell: (row) => (
        !loading ? (
          (() => {
            let textColor;
            let backgroundColor;
            let stockLabel;

            switch (row.manage_stock?.stock_status) {
              case "inStock":
                textColor = "#5285B4";
                backgroundColor = "#5285B4" + "10";
                stockLabel = "In Stock";
                break;
              case "outStock":
                textColor = "#F08F9F";
                backgroundColor = "#F08F9F" + "10";
                stockLabel = "Out of Stock";
                break;
              case "lowStock":
                textColor = "#F4B074";
                backgroundColor = "#F4B074" + "10";
                stockLabel = "Low Stock";
                break;
              default:
                textColor = "#36454F";
                backgroundColor = "transparent";
                stockLabel = "Undefined";
            }

            return (
              <div
                style={{
                  color: textColor,
                  backgroundColor: backgroundColor,
                  padding: "5px 10px 5px 10px",
                  borderRadius: "5px",
                  boxSizing: "border-box",
                  display: "inline-block",
                  fontWeight: 600,
                }}
              >
                {stockLabel}
              </div>
            );
          })()
        ) : (
          <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
        )
      ),
      minWidth: "135px",
      maxWidth: "175px",
      omit: isSmallScreen,
    },
    {
      name: "Price",
      selector: (row) => {
        if (loading) {
          return <ShimmerLoader width="60px" height="22.5px" borderRadius="20px" />;
        }

        const salePrice = row.sale_price;
        const useRegular = salePrice === "" || salePrice === 0 || salePrice === null;

        const priceToShow = useRegular ? row.regular_price : salePrice;
        const formattedPrice = new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(priceToShow);

        let textColor;
        let backgroundColor;
        let stockLabel;

        switch (row.manage_stock?.stock_status) {
          case "inStock":
            textColor = "#5285B4";
            backgroundColor = "#5285B4" + "10";
            stockLabel = "In Stock";
            break;
          case "outStock":
            textColor = "#F08F9F";
            backgroundColor = "#F08F9F" + "10";
            stockLabel = "Out of Stock";
            break;
          case "lowStock":
            textColor = "#F4B074";
            backgroundColor = "#F4B074" + "10";
            stockLabel = "Low Stock";
            break;
          default:
            textColor = "#36454F";
            backgroundColor = "transparent";
            stockLabel = "Undefined";
        }

        return (
          <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "5px"
          }}>

            <span style={{ color: useRegular ? "maroon" : "inherit" }}>
              {formattedPrice}
            </span>
            {isSmallScreen && <div
              style={{
                color: textColor,
                backgroundColor: backgroundColor,
                padding: "5px 10px 5px 10px",
                borderRadius: "5px",
                boxSizing: "border-box",
                display: "inline-block",
                fontWeight: 600,
              }}
            >
              {stockLabel}
            </div>}
          </div>
        );
      },
      minWidth: "100px",
      maxWidth: "140px",
    },
    {
      name: "Product Tag",
      selector: (row) => (
        !loading ? (
          row.product_tag ? (
            <span
              key={row.product_tag._id}
              style={{
                display: "inline-block",
                backgroundColor: row.product_tag.bg_color
                  ? `${row.product_tag.bg_color}80`
                  : "rgba(221, 221, 221, 0.5)",
                color: row.product_tag.text_color || "#000",
                padding: "5px 10px",
                borderRadius: "4px",
                fontSize: "12px",
                fontWeight: "600",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            >
              {row.product_tag.text || row.product_tag.name}
            </span>
          ) : (
            "N/A"
          )
        ) : (
          <ShimmerLoader width="80px" height="22.5px" borderRadius="20px" />
        )
      ),
      minWidth: "160px",
      maxWidth: "180px"
    },
    {
      name: "Category",
      selector: (row) => (
        loading ? (
          <ShimmerLoader width="90px" height="22.5px" borderRadius="20px" />
        ) : (
          (() => {
            let textColor;
            let bgColor;
            let displayText;

            if (row.parent === 0) {
              displayText = "Product";
              textColor = "#5285B4";
              bgColor = "transparent";
            } else {
              displayText = "Variation";
              textColor = "#F4B074";
              bgColor = "transparent";
            }

            const mainCategory = row.categories?.find((category) => category.is_main === 1);
            const fallbackCategory = row.categories?.[0];
            return (
              <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "2px"
              }}>
                {mainCategory?.name || fallbackCategory?.name || "N/A"}
                {isSmallScreen && <div
                  style={{
                    color: textColor,
                    backgroundColor: bgColor,
                    padding: "5px 10px",
                    borderRadius: "5px",
                    display: "inline-block",
                    fontWeight: 600,
                  }}
                >
                  {displayText}
                </div>}
              </div>
            );
          })()
        )
      ),
      minWidth: "125px",
      maxWidth: "160px",
      // omit: isSmallScreen,
    },
    // {
    //   name: "Status",
    //   cell: (row) => (
    //     loading ? (
    //       <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
    //     ) : (
    //       (() => {
    //         let textColor;
    //         let bgColor;
    //         switch (row.status) {
    //           case "draft":
    //             textColor = "#F4B074";
    //             bgColor = "transparent";
    //             break;
    //           case "published":
    //             textColor = "#5285B4";
    //             bgColor = "transparent";
    //             break;
    //           default:
    //             textColor = "#8DF9A1";
    //             bgColor = "#8DF9A11A";
    //             break;
    //         }

    //         const capitalizeStatus = row.status
    //           ? row.status.charAt(0).toUpperCase() +
    //           row.status.slice(1).toLowerCase()
    //           : "Unknown";

    //         return (
    //           <div
    //             style={{
    //               color: textColor,
    //               backgroundColor: bgColor,
    //               padding: "5px 10px",
    //               borderRadius: "5px",
    //               display: "inline-block",
    //               fontWeight: 600,
    //             }}
    //           >
    //             {capitalizeStatus}
    //           </div>
    //         );
    //       })()
    //     )
    //   ),
    //   minWidth: "120px",
    //   maxWidth: "200px",
    // },
    {
      name: "Status",
      cell: (row) => (
        loading ? (
          <ShimmerLoader width="100px" height="22.5px" borderRadius="20px" />
        ) : (
          (() => {
            let textColor;
            let bgColor;
            let displayText;

            if (row.parent === 0) {
              displayText = "Product";
              textColor = "#5285B4";
              bgColor = "transparent";
            } else {
              displayText = "Variation";
              textColor = "#F4B074";
              bgColor = "transparent";
            }

            return (
              <div
                style={{
                  color: textColor,
                  backgroundColor: bgColor,
                  padding: "5px 10px",
                  borderRadius: "5px",
                  display: "inline-block",
                  fontWeight: 600,
                }}
              >
                {displayText}
              </div>
            );
          })()
        )
      ),
      minWidth: "120px",
      maxWidth: "200px",
      omit: isSmallScreen,

    },

    {
      name: "Action",
      cell: (row) => (loading ? <ShimmerLoader width="60px" height="22.5px" /> :
        <div style={{ position: "relative" }}>
          <img
            src={actionIcon}
            alt="Action Icon"
            width="40"
            height="40"
            style={{ cursor: "pointer", margin: 0, padding: 0 }}
            className={`bar-icon ${openDropdownId === row._id ? "rotated" : ""
              }`}
            onClick={() => toggleDropdown(row._id)}
          />
          {openDropdownId === row._id && (
            <div className={`dropdown-menu show animate-dropdown-left`}>
              <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                <li
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  onClick={() => handleAction("view", row)}
                >
                  <IoEyeOutline style={{ marginRight: "12px" }} className="icon-img-updated" />
                  View
                </li>
                {!row?.outSource && <li
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  onClick={() => handleAction("edit", row)}
                >
                  <FiEdit style={{ marginRight: "12px" }} className="icon-img-updated" />
                  Edit
                </li>}
                <li
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  onClick={() => handleAction("duplicate", row)}
                >
                  <FiEdit style={{ marginRight: "12px" }} className="icon-img-updated" />
                  Edit Pricing 
                </li>
                <li
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "5px 10px",
                    border: "none",
                  }}
                  onClick={() => handleAction("delete", row)}
                >
                  <RiDeleteBin6Line style={{ marginRight: "12px" }} className="icon-img-updated" />
                  Delete
                </li>
              </ul>
            </div>
          )}
        </div>
      ),
      minWidth: "80px",
      maxWidth: "120px",
    },
  ];

  const handleEdit = (row) => {
    navigate((`/E-Commerce/Edit-Product/${row._id}`), { state: { productData: row } });
  };

  const handleView = (row) => {
    navigate((`/E-Commerce/View-Product/${row._id}`), { state: { viewData: row } });
  };


  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // triggers useEffect
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1); // triggers useEffect
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1); // triggers useEffect
    }
  };

  const placeholderRows = Array(7).fill({ uid: "", name: "", image: "" });

  const displayedData = loading ? placeholderRows : filteredData;
  const [filterLoading, setFilterLoading] = useState(false);


  return (
    <div className="AllProductPage">

      <div className="sectionall_1">
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
          }}
        >
          <SearchBar onSearch={handleSearch} icon={searchIcon} />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            marginRight: "15px",
          }}
        >
          <CustomBtn
            label="Add Product"
            withIcon={true}
            iconType="plus"
            className="AddBtn"
            onClick={handleAddProduct}
            type="submit"
          />
          <CustomBtnLogo
            image={logo}
            label="Set Merchant Center"
            withIcon={true}
            iconType="import"
            onClick={setMerchantSystem}
            type="button"
          />
          <CustomBtn
            label="Export"
            withIcon={true}
            iconType="import"
            className="ExportBtn"
            onClick={handleExport}
            type="button"
          />
        </div>
      </div>

      <div className="sectionall_2">
        <Accordion allowZeroExpanded className="accordion">
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Filters</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <div className="filter-row-01" style={{ gridTemplateColumns: "2fr 2fr 2fr 1fr" }}>
                <div className="filter-label">Stock</div>
                <div className="filter-label">Product Status</div>
                <div className="filter-label">Trending Product</div>
                <div className="filter-label">Rating</div>
                {/* <div className="filter-label">Product Rating</div> */}
              </div>

              <div className="filter-row-02" style={{ gridTemplateColumns: "2fr 2fr 2fr 1fr" }}>

                <div className="custom-dropdown-wrapper-Filter">
                  <CustomDropdown
                    options={productStockOptions}
                    selectedOption={
                      selectedStockStatus
                    }
                    handleOptionChange={(value) =>
                      handleFilterChange(value, "stock")
                    }
                    dropdownWidth={'100%'}
                    dropdownMarginBottom="13px"
                    backgroundColor="var(--third-layer-bg)"
                    optionsWidth={'100%'}
                    optionsBackgroundColor="var(--third-layer-bg)"
                    optionsHeight={"auto"}
                    dropdownSelectedStyle="7px"
                  />
                </div>

                <div className="custom-dropdown-wrapper-Filter">
                  <CustomDropdown
                    options={productStatusOptions}
                    selectedOption={
                      selectedProductStatus
                    }
                    handleOptionChange={(value) =>
                      handleFilterChange(value, "status")
                    }
                    dropdownWidth={'100%'}
                    dropdownMarginBottom="13px"
                    backgroundColor="var(--third-layer-bg)"
                    optionsWidth={'100%'}
                    optionsBackgroundColor="var(--third-layer-bg)"
                    optionsHeight={"auto"}
                    dropdownSelectedStyle="7px"
                  />
                </div>

                <div className="custom-dropdown-wrapper-Filter">
                  <CustomDropdown
                    options={trendingOptions}
                    selectedOption={selectedTrandingStatus || []}

                    handleOptionChange={(value) =>
                      handleFilterChange(value, "tranding")
                    }
                    dropdownWidth={'100%'}
                    dropdownMarginBottom="13px"
                    backgroundColor="var(--third-layer-bg)"
                    optionsWidth={'100%'}
                    optionsBackgroundColor="var(--third-layer-bg)"
                    optionsHeight={116}
                    dropdownSelectedStyle="7px"
                  // isMulti={true}
                  />
                </div>

                <div className="custom-dropdown-wrapper-Filter">
                  <CustomDropdown
                    options={ratingOptions}
                    selectedOption={
                      rating
                    }
                    handleOptionChange={(value) =>
                      handleFilterChange(value, "rating")
                    }
                    dropdownWidth={'100%'}
                    dropdownMarginBottom="13px"
                    backgroundColor="var(--third-layer-bg)"
                    optionsWidth={'100%'}
                    optionsBackgroundColor="var(--third-layer-bg)"
                    optionsHeight={"auto"}
                    dropdownSelectedStyle="7px"
                  />
                </div>


                {/* <div className="StarRating-Div">
                  <RatingReview
                    rating={rating}
                    setRating={(newRating) =>
                      handleFilterChange(newRating, "rating")
                    }
                    disabled={false}
                    size="35px"
                  />
                </div> */}
              </div>




              <div className="filter-row-01" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>
                <div className="filter-label">Collection</div>
                <div className="filter-label">Tag</div>
                <div className="filter-label">Price Range</div>
                <div className="filter-label">Date Range</div>
                {/* <div className="filter-label">Product Rating</div> */}
              </div>

              <div className="filter-row-02" style={{ gridTemplateColumns: "1fr 1fr 1fr 1fr" }}>

                <div className="custom-dropdown-wrapper-Filter">
                  <SearchSingle
                    name="collection-select"
                    placeholder="Search & Select Collection..."
                    options={collections.map(col => col.label)} // component expects string list
                    selectedItem={selectedCollection.label}     // show only label
                    onSelect={(selectedLabel) => {
                      if (!selectedLabel) {
                        setSelectedCollection({ label: "", value: "" }); // clear selection
                        return;
                      }

                      const selectedObj = collections.find(col => col.label === selectedLabel);
                      if (selectedObj) {
                        setSelectedCollection(selectedObj);
                      }
                    }}

                    width="100%"
                    minheight="40px"
                    suggestionHeight="70px"
                  />

                </div>



                <div className="custom-dropdown-wrapper-Filter">
                  <SearchMultiple
                    name="multiSelect-Tag"
                    placeholder="Search & Select Tag..."
                    options={tags.map((tag) => tag.name)}
                    onSelect={(option) => handleTagSelect(option)}
                    selectedItems={selectedTags.map((tag) => tag.name)}
                    width="100%"
                    minheight="40px"
                    suggestionHeight="70px"
                  />
                </div>
                <PriceRange
                  placeholder="Enter Max. Amount"
                  value={priceRange}
                  name="priceRange"
                  onChange={(e) =>
                    handleFilterChange(e.target.value, "priceRange")
                  }
                  readOnly={false}
                />

                <div className="Order-filter-date-wrapper">
                  <RangePicker
                    format="YYYY-MM-DD"
                    onChange={(dates) => handleFilterChange(dates, "date")}
                    value={dateRange}
                    style={{ width: "100%", height: "clamp(40px, 6vh, 48px)" }}
                    disabledDate={disabledDate}
                  />
                </div>
              </div>

              <div className="filter-row-03" style={{ gridTemplateColumns: "3fr 3fr" }}>
                <div className="filter-label">Category</div>
              </div>

              <div className="filter-row-02" style={{ gridTemplateColumns: "3fr 3fr" }}>
                <div className="custom-dropdown-wrapper-Filter">
                  <SearchMultiple
                    name="multiSelect-Cat"
                    placeholder="Search & Select Category..."
                    options={categories.map((category) => category.label)}
                    onSelect={(option) => handleCategorySelect(option)}
                    selectedItems={selectedCategories.map(
                      (category) => category.label
                    )}
                    width="100%"
                    minheight="40px"
                    suggestionHeight="70px"
                  />
                </div>


              </div>

              {/* <ToggleSwitch checked={showVariations} setChecked={setShowVariations} /> */}
              <div style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                gap: "30px",
                marginTop: "15px"
              }}>
                <CustomCheckbox
                  id="dyrc"
                  label="Design Your Room"
                  checked={showDyrc}
                  setChecked={setShowDyrc}
                />
                <CustomCheckbox
                  id="variations"
                  label="Variations"
                  checked={showVariations}
                  setChecked={setShowVariations}
                />

                <CustomCheckbox
                  id="sub_products"
                  label="Show Sub Products"
                  checked={showSubProducts}
                  setChecked={setShowSubProducts}
                />


              </div>

              <div className="filter-row-04">
                {!filtersApplied ? (
                  <button type="submit" onClick={() => { handleFilters(filtersPayload, currentPage); }} className="apply_filter_btn">
                    {filterLoading ? <div
                      style={{ borderTop: "4px solid white" }}
                      className="btn-loader-Publish"
                    ></div> : "Apply Filter"}
                  </button>

                ) : (
                  <>
                    <CustomBtn
                      label="Reset"
                      withIcon={true}
                      iconType="reset"
                      className="ResetBtn-OrderPage"
                      onClick={handleResetFilters}
                      type="button"
                    />
                    <button type="submit" onClick={() => { handleFilters(filtersPayload, currentPage); }} className="apply_filter_btn">
                      {filterLoading ? <div
                        style={{ borderTop: "4px solid white" }}
                        className="btn-loader-Publish"
                      ></div> : "Apply Filter"}
                    </button>
                  </>
                )}
              </div>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>

      {selectedRows.length > 0 && <div className="delete_btn_sec">
        <button onClick={() => {
          confirmBulkDelete()
        }}>
          ⚠️ Delete
        </button>
      </div>}

      <div className="sectionall_3">
        <div>
          <DataTable
            columns={ProductsColumns}
            data={displayedData}
            customStyles={customStyles}
          />
          <ElipticalPagenation
            activePageIndex={currentPage}
            totalPages={totalPages}
            onPrevPage={handlePrevPage}
            onNextPage={handleNextPage}
            onPageChange={handlePageChange}
          />

        </div>
      </div>

      {/* --- (PopUp) To Handle Confiramtion for Delete Operation of Single Category --- */}
      {showConfirm && (
        <div className="confirmation-modal">
          <div className="Cat-modal-content" ref={modalRef}>
            <CiWarning className="warning-icon" />
            <div className="Delete-Heading">Warning</div>
            <div className="Delete-Content">
              Are you sure you want to delete this Product? <br />
              This action cannot be undone.
            </div>
            <div className="separator-line"></div>
            <div className="modal-actions">
              <button
                className="Cat-Delete-btn btn-secondary"
                onClick={cancelDelete}
              >
                Cancel
              </button>

              <div className="SubmitBtn">
                <CustomBtn
                  label={
                    isLoading ? (
                      <div className="btn-loader-Category"></div>
                    ) : (
                      "Confirm"
                    )
                  }
                  className={`Cat-Delete-btn btn-danger ${isActive ? "active" : ""
                    }`}
                  disabled={isLoading}
                  onClick={handleDelete}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <BottomToust
        showMessage={showMessage}
        message={toastMessage}
        handleCloseMessageModal={() => handleCloseMessageModal()}
      />

      {merchantLoading && <div className="backdrop">
        <div className="loader-container">
          <MainLoader heading1={"Updating Merchant Center"} />
        </div>
      </div>}

      {showAllConfirm && (
        <div className="confirmation-modal">
          <div className="Cat-modal-content" ref={modalRef}>
            <CiWarning className="warning-icon" />
            <div className="Delete-Heading">Warning</div>
            <div className="Delete-Content">
              Are you sure you want to delete all selected categories? <br />
              This action cannot be undone.
            </div>
            <div className="separator-line"></div>
            <div className="modal-actions">
              <button
                className="Cat-Delete-btn btn-secondary"
                onClick={() => { setShowAllConfirm(false) }}
              >
                Cancel
              </button>
              <div className="SubmitBtn">
                <CustomBtn
                  label={
                    isLoading ? (
                      <div className="btn-loader-Category"></div>
                    ) : (
                      "Confirm"
                    )
                  }
                  className={`Cat-Delete-btn btn-danger ${isActive ? "active" : ""
                    }`}
                  disabled={isLoading}
                  onClick={() => {
                    // BulkDelete();
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      <PriceChangePopUp
        showPriceChangePopup={showProductPChangeModal}
        productData={productPChange}
        onClose={() => { setProductPChange(null); setShowProductPChangeModal(false) }}
        onUpdate={
          updateProduct}
      />


    </div>
  );
};

export default AllProducts;